<template>
  <div class="row w-100 m-0 grayish p-2">
    <div class="col-md-12 bg-white rounded py-4">
      <div class="tag-badge-custom d-flex align-items-center pr-2 pl-1">
        <span class="fa-stack fa-xs">
          <em class="far fa-circle fa-stack-2x double text-white" />
          <em class="fas fa-circle fa-stack-2x green" />
          <em class="fas fa-info-circle fa-stack-1x fa-inverse" />
        </span>
        <span class="py-1 pl-1 font-weight-bold mb-0">
          Información Adicional
        </span>
      </div>

      <div class="row">
        <div class="col-12 mt-3">
          <div class="d-flex align-items-center mb-2">
            <i class="fas fa-calendar-day text-orange ml-2"></i>
            <div class="font-16 font-weight-bold ml-2">
              Información de Fechas de Proceso
            </div>
          </div>
          <div class="ml-4">
            <div class="row">
              <div class="col-md-2 col-12 ml-2">
                <span class="data-title">Fecha de Solicitud:</span>
                <p>
                  {{ data.requestDate | date | empty }}
                </p>
              </div>
              <div class="col-md-3 col-12">
                <span class="data-title">Fecha de Citas:</span>
                <p>{{ appointmentDates.join(', ') | empty }}</p>
              </div>
              <div class="col-md-3 col-12">
                <span class="data-title">Fecha de Evaluación:</span>
                <p>
                  {{ data.evaluationDate | date | empty }}
                </p>
              </div>
              <div class="col-md-3 col-12">
                <span class="data-title">Fecha de Envío Discusión:</span>
                <p>
                  {{ data.sentToDiscussionDate | date | empty }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 my-3">
          <div class="d-flex align-items-center mb-2">
            <i class="fas fa-arrow-circle-right ml-2 text-orange"></i>
            <div class="font-16 font-weight-bold ml-2">
              Información de Estatus
            </div>
          </div>
          <div class="ml-4">
            <div class="row">
              <div class="col-md-3 col-12 ml-2">
                <span class="data-title">Fecha de Estatus:</span>
                <p>{{ data.status?.date | date | empty }}</p>
              </div>
              <div class="col-md-3 col-12">
                <span class="data-title">Razón de Estatus:</span>
                <p>{{ data.status?.reason | empty }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ReferralInfoPanel',
  props: {
    peiAtServiceId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return { data: {}, appointmentDates: [] };
  },
  async mounted() {
    this.$ApiGet(`/api/atservice/additionalinfo/${this.peiAtServiceId}`).then(
      (res) => {
        this.data = res.data;
        res.data.appointmentDates.forEach((element) => {
          this.appointmentDates.push(
            moment(element)
              .locale('es')
              .format('DD/MMM/YYYY')
          );
        });
      }
    );
  },
};
</script>

<style scoped>
.tag-badge-custom {
  width: 205px;

  border-radius: 26px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
}

.green {
  color: #2db782;
}
</style>
